<template>
  <a-menu
    :selectedKeys="selectedKeys"
    mode="horizontal"
    :items="menuItems"
    @click="handleClick"
  ></a-menu>
</template>

<script>
import { h } from "vue";
import * as Icons from "@ant-design/icons-vue";

export default {
  name: "TopMenu",
  props: {
    selectedKeys: {
      type: Array,
      default: () => [],
    },
    menuList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    menuItems() {
      return this.menuList.map((item) => ({
        key: item.routerName,
        label: this.$t(item.nameTag),
        icon: item.icon ? () => h(Icons[item.icon]) : null,
        children:
          item.children?.map((child) => ({
            key: child.routerName,
            label: this.$t(child.label),
          })) || null,
      }));
    },
  },
  mounted() {
    let key = this.$route.query.key;
    if (key) {
      this.handleClick(key);
    }
  },
  methods: {
    handleClick({ key }) {
      this.$emit("update:selectedKeys", [key]);
      this.$emit("set-menu", key);
    },
  },
};
</script>

<style scoped></style>
